import { useMemo } from "react";
import { Card, Col, Row } from "react-bootstrap";
import {
  FaCar,
  FaHome,
  FaPhoneAlt,
  FaSwimmingPool,
  FaTree,
  FaTshirt,
  FaUtensils,
  FaWarehouse
} from "react-icons/fa";

const facilityIconMap = {
  kolam_renang: FaSwimmingPool,
  pool: FaSwimmingPool,
  taman: FaTree,
  garden: FaTree,
  garasi: FaWarehouse,
  carport: FaCar,
  kitchen: FaUtensils,
  laundry: FaTshirt,
  telepon: FaPhoneAlt,
  default: FaHome,
};

function getFacilityIcon(key) {
  const Icon = facilityIconMap[key] || facilityIconMap.default;
  return <Icon />;
}

function normalizeFacility(item) {
  if (!item) return null;

  if (typeof item === "string") {
    return { label: item, icon: item.toLowerCase() };
  }

  if (typeof item === "object") {
    return {
      label: item.label || item.name || item.title || "Fasilitas",
      icon: item.icon || item.key || item.slug || "default",
    };
  }

  return null;
}

const FacilityGroup = ({ title, items }) => {
  if (!items.length) return null;

  return (
    <div className="mb-4">
      <div className="detail-subtitle mb-3">{title}</div>
      <Row className="g-3">
        {items.map((item, index) => (
          <Col xs={6} md={4} key={`${title}-${item.label}-${index}`}>
            <div className="facility-item">
              <div className="facility-icon">{getFacilityIcon(item.icon)}</div>
              <div className="facility-label">{item.label}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const DetailFacilities = ({ houseFacilities = [], projectFacilities = [] }) => {
  const houseItems = useMemo(
    () => houseFacilities.map(normalizeFacility).filter(Boolean),
    [houseFacilities],
  );

  const projectItems = useMemo(
    () => projectFacilities.map(normalizeFacility).filter(Boolean),
    [projectFacilities],
  );

  if (!houseItems.length && !projectItems.length) {
    return null;
  }

  return (
    <Card className="detail-card">
      <Card.Body className="detail-card-body">
        <h3 className="section-title">Fasilitas</h3>

        <FacilityGroup title="Fasilitas Rumah" items={houseItems} />
        <FacilityGroup title="Fasilitas Perumahan" items={projectItems} />
      </Card.Body>
    </Card>
  );
};

export default DetailFacilities;
